interface ReferensData {
    journalId: string;
    selectedOption: string;
}

interface ReferensSlice {
    referensData: ReferensData;
    setReferensData: (data: ReferensData) => void;
    updateReferensField: (field: keyof ReferensData, value: any) => void;
    resetReferensData: () => void;
}

const createReferensSlice = (set: any) => ({
    referensData: {
        journalId: '',
        selectedOption: 'option1',
    },
    setReferensData: (data: ReferensData) =>
        set({
            referensData: data,
        }),
    updateReferensField: (field: keyof ReferensData, value: any) =>
        set((state: ReferensSlice) => ({
            referensData: {
                ...state.referensData,
                [field]: value,
            },
        })),
    resetReferensData: () =>
        set({
            referensData: {
                journalId: '',
                selectedOption: 'option1',
            },
        }),
});

export { createReferensSlice };
export type { ReferensData, ReferensSlice };
